export { default as Avatar, AvatarPropsShape, type AvatarProps } from './Avatar';
export { ContactAvatar, type ContactAvatarProps } from './ContactAvatar';
export { OrgAvatar, type OrgAvatarProps } from './OrgAvatar';
export { default as TeamUserAvatar } from './TeamUserAvatar';
export { default as TeamAvatar } from './TeamAvatar';
export type { TeamLogo } from './TeamAvatar';